var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6 24.2453C51.1722 24.2453 56.5 18.9175 56.5 12.3453C56.5 5.77312 51.1722 0.445313 44.6 0.445313C38.0278 0.445313 32.7 5.77312 32.7 12.3453C32.7 13.0619 32.7633 13.7636 32.8847 14.4453L1.5 14.4453C0.947715 14.4453 0.5 14.893 0.5 15.4453L0.5 20.4453C0.5 20.9976 0.947716 21.4453 1.5 21.4453L36.9315 21.4453C39.0026 23.1924 41.6783 24.2453 44.6 24.2453ZM41.4819 6.99031L39.5756 8.77531L43.1421 12.5796L39.2561 16.1778L41.1132 17.9743L44.9154 14.471L48.5006 18.2953L50.2856 16.4271L46.8219 12.7144L50.6044 9.22925L48.8312 7.31193L45.049 10.814L41.4819 6.99031ZM1.5 26.112C0.947715 26.112 0.5 26.5597 0.5 27.112L0.5 48.4453C0.5 48.9976 0.947716 49.4453 1.5 49.4453H46.1667C46.7189 49.4453 47.1667 48.9976 47.1667 48.4453V27.112C47.1667 26.5597 46.7189 26.112 46.1667 26.112L1.5 26.112ZM15.6667 31.9453H5.16667L5.16667 37.7786H15.6667V31.9453Z",
    fill: "#FF5326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.052088696e99b52652196f392000fed2.svg";
export { ForwardRef as ReactComponent };